import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AuthGuard } from './shared/guard';
import { AuthInterceptor } from '@vendor/core/interceptors/auth.interceptor';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { Config } from '@vendor/config/config';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginGuard } from './shared/guard/login.guard';
import { HelpMessagesService } from '@vendor/static-data/help-messages.service';
import { SharedComponentModule } from '@vendor/shared-component/shared-component.module';
import { AngularResizedEventModule } from 'angular-resize-event';
import { RegisterGuard } from './shared/guard/register.guard';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { StoreModule } from '@ngrx/store';
import { reducer } from './store/reducers/route-stack.reducer';
import { MomentModule } from 'angular2-moment';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { PwaDesktopComponent } from './components/pwa-desktop/pwa-desktop.component';
import { RotatePhoneLockComponent } from './components/rotate-phone-lock/rotate-phone-lock.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ChartsModule } from 'ng2-charts';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};
@NgModule({
  declarations: [
    AppComponent,
    PwaDesktopComponent,
    RotatePhoneLockComponent
  ],
  imports: [
    SharedComponentModule,
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularResizedEventModule,
    BackButtonDisableModule.forRoot(),
    StoreModule.forRoot({
      routeStack: reducer
    }),
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
    SwiperModule,
    ZXingScannerModule,
    ChartsModule
  ],
  providers: [
    AuthGuard,
    Config,
    HttpClientModule,
    LoginGuard,
    RegisterGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    HelpMessagesService,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
